<template>
  <div class="feedback">
    <div class="commonBg"></div>
    <div class="uploadPage_toptitle">
      <div class="uploadPage_toptitlebox">
        <van-icon name="arrow-left" @click="back" />
        <div class="details_top_title">建议与反馈</div>
        <van-icon name="close" v-show="
          $store.state.system == 'android' &&
          applets != 'xcx' &&
          !$store.state.isXcx &&
          $store.state.isInGame
        " @click="closeCommunity" />
        <!-- <van-icon name="close" /> -->
      </div>
    </div>
    <div class="feedback_top">
      <div class="feedback_top_title">问题类型<span>（必填）</span></div>
      <div class="feedback_top_typelist">
        <div class="feedback_top_typeitem" :class="item.cur ? 'feedback_top_typeitemcur' : ''" v-for="item in problemType"
          :key="item.id" @click="problemTypeClick(item)">
          {{ item.name }}
        </div>
      </div>
      <div>
        <van-field id="field" v-model="value" rows="2" autosize label="" type="textarea"
          placeholder="说说你的建议或遇到的问题（不少于10个字）" show-word-limit />
      </div>
      <div class="feedback_top_addimgbox">
        <div class="feedback_top_addimg" :class="item.img != '' ? 'feedback_top_addimg_have' : ''" v-for="item in addimg"
          :key="item.id">
          <img v-show="item.img != ''" :src="item.img" />
          <div v-show="item.img != ''" class="feedback_top_addimg_deleteicon" @click="deleteimg(item)"></div>
          <input v-show="item.img == ''" ref="addimg3" :type="file1" accept="image/*" class="file-btn"
            @change="addFile($event, item.id)" />
        </div>
      </div>
    </div>
    <div class="feedback_contact">
      <div class="feedback_contact_title">联系方式（选填）</div>
      <div class="feedback_contact_input">
        <van-field v-model="tel" placeholder="输入手机号或邮箱" />
      </div>
    </div>
    <div class="feedback_subbtn" @click="submit">提交</div>
  </div>
</template>
<script>
import { Toast } from 'vant';
import lrz from 'lrz';
import http from '../../../../api/get';
import qs from 'qs';
import * as _code from '../../../../utils/code';
export default {
  name: 'feedback',
  data() {
    return {
      applets: window.user.weixcode ? "xcx" : "",
      imgcur: 0,
      value: '',
      tel: '',
      feedbackType: 0,
      problemType: [
        { id: 0, name: '功能异常', cur: false, type: 1 },
        { id: 1, name: '社区体验', cur: false, type: 2 },
        { id: 2, name: '账号问题', cur: false, type: 3 },
        { id: 3, name: '其他', cur: false, type: 4 }
      ],
      addimg: [
        { id: 0, img: '', minimg: '' },
        { id: 1, img: '', minimg: '' },
        { id: 2, img: '', minimg: '' },
        { id: 3, img: '', minimg: '' }
      ],

      qaFlag: /^(test|qa)-/.test(location.hostname),
      Bucket: '',
      Region: '',
      allowPrefix: '',
      protocol: 'https:',
      file1: 'file' //input数据类型
    };
  },
  methods: {
    problemTypeClick(item) {
      this.problemType.forEach((item, index) => {
        item.cur = false;
      });
      item.cur = true;
      this.feedbackType = item.type;
    },
    submit() {
      if (this.feedbackType == 0) {
        Toast('请选择问题类型');
        return;
      }
      if (this.value == '') {
        Toast('请输入建议内容');
        return;
      }
      if (this.value.length < 11) {
        Toast('问题不能少于10个字');
        return;
      }
      let pictures = [];
      this.addimg.forEach((item, index) => {
        if (item.img != '') {
          let obj = {
            path: item.img
          };
          pictures.push(obj);
        }
      });
      let obj = {
        content: this.value,
        feedbackType: this.feedbackType,
        remark: this.tel,
        pictures: JSON.stringify(pictures)
      };
      http.feedback(qs.stringify(obj)).then((res) => {
        let data = res.data;
        if (data.code == 0) {
          Toast('反馈成功');
          this.back();
        } else {
          this.errorMessage(data);
        }
      });
    },
    back() {
      this.$emit('changePage', 0);
    },
    //错误提示
    errorMessage(data) {
      let code = data.code;
      if (code != 2050) {
        let voteErr = _code.code.vote;
        let msg = voteErr[code] ? voteErr[code] : voteErr['other'] + code;
        Toast(msg);
      }
    },
    //图片上传
    addFile(e, id) {
      this.imgcur = id;
      let _this = this;
      var par = $(this).parent();
      var pline = $(this).parent().find('progress_line');
      var file = e.target.files[0];
      var indexNum = file.name.lastIndexOf('.');
      var lastName = file.name.substr(indexNum + 1);
      var nameArr = ['gif', 'jpg', 'jpeg', 'png', 'GIF', 'JPG', 'PNG'];
      var imgFlag = false;
      for (var i = 0; i < nameArr.length; i++) {
        if (lastName == nameArr[i]) {
          imgFlag = true;
        }
      }
      setTimeout(function () {
        if (imgFlag) {
          if ((file.size / (1024 * 1024)).toFixed(3) <= 5) {
            //小于5M
            file.newName =
              // $(".userInfo").val() +
              '_' + +new Date() + '.' + file.name.split('.')[1];
            try {
              lrz(file, { width: 1024 })
                .then(function (rst) {
                  rst.file.newName =
                    file.newName.split('.')[0] +
                    '_ys.' +
                    file.newName.split('.')[1];
                  rst.file &&
                    _this.uploadFile(rst.file, function (err, data) {
                      if (data) {
                        // _this.addimg[_this.imgcur].minimg = data.url;
                      } else {
                        Toast(err);
                      }
                    });
                })
                .always(function () {
                  // return;
                  file &&
                    _this.uploadFile(
                      file,
                      function (err, data) {
                        if (data) {
                          _this.addimg[_this.imgcur].img = data.url.replace(
                            'snspic-1251257918.cos.ap-shanghai.myqcloud.com',
                            'snspic.zlongame.com'
                          );
                          console.log(_this.addimg[_this.imgcur].img);
                          par.attr('url', _this.addimg[_this.imgcur].img);
                        } else {
                          Toast(err);
                        }
                      },
                      par
                    );
                });
            } catch (err) {
              console.log(err);
              Toast(err);
            }
          } else {
            Toast('图片太大啦！请选择5M以内的图片上传哦~');
            _this.file1 = 'text';
            setTimeout(function () {
              _this.file1 = 'file';
            }, 30);
          }
        } else {
          Toast('图片格式不对，请选择PNG或者JPG形式上传哦~');
        }
      }, 600);
      // })
    },
    // 计算签名
    getAuthorization(options, callback) {
      http.getCosTemToken().then((res) => {
        var data;
        try {
          data = new Function('return ' + JSON.stringify(res.data.data))();
          this.allowPrefix = data.allowPrefix;
          this.Region = data.region;
          this.Bucket = data.bucketName;
        } catch (res) { }
        if (data) {
          callback(null, {
            XCosSecurityToken: data.credentials.sessionToken,
            Authorization: CosAuth({
              SecretId: data.credentials.tmpSecretId,
              SecretKey: data.credentials.tmpSecretKey,
              Method: options.Method,
              Pathname: options.Pathname
            })
          });
        } else {
          callback('获取签名出错');
        }
      });
    },
    uploadFile(file, callback, obj) {
      var self = this;
      var Key =
        // "sns/front/" +
        new Date().getFullYear() +
        '/' +
        (new Date().getMonth() + 1) +
        '/' +
        file.newName; // 这里指定上传目录和文件名
      self.getAuthorization(
        { Method: 'PUT', Pathname: '/' + Key },
        function (err, info) {
          if (err) {
            alert(err);
            return;
          }
          let prefix =
            self.protocol +
            '//' +
            self.Bucket +
            '.cos.' +
            self.Region +
            '.myqcloud.com/';
          var auth = info.Authorization;
          var XCosSecurityToken = info.XCosSecurityToken;
          var url =
            prefix +
            self.allowPrefix +
            self.camSafeUrlEncode(Key).replace(/%2F/g, '/');
          var xhr = new XMLHttpRequest();
          xhr.open('PUT', url, true);
          xhr.setRequestHeader('Authorization', auth);
          XCosSecurityToken &&
            xhr.setRequestHeader('x-cos-security-token', XCosSecurityToken);
          xhr.upload.onprogress = function (e) {
            if (obj) {
            }
          };
          xhr.onload = function () {
            if (xhr.status === 200 || xhr.status === 206) {
              var ETag = xhr.getResponseHeader('etag');
              callback(null, { url: url, ETag: ETag });
            } else {
              callback('上传失败，状态码：' + xhr.status);
            }
          };
          xhr.onerror = function () {
            callback('上传失败，请检查是否配置跨域规则');
          };
          xhr.send(file);
        }
      );
    },
    camSafeUrlEncode(str) {
      return encodeURIComponent(str)
        .replace(/!/g, '%21')
        .replace(/'/g, '%27')
        .replace(/\(/g, '%28')
        .replace(/\)/g, '%29')
        .replace(/\*/g, '%2A');
    },
    closeCommunity() {
      window.pd.onBBSClose();
    },
    deleteimg(item) {
      this.addimg[item.id].minimg = '';
      this.addimg[item.id].img = '';
    }
  }
};
</script>
<style scoped></style>